/* istanbul ignore next */
import { NavigateFunction } from 'react-router-dom';
import { persistor, store } from '../redux/store';

export const handleGoBackTo = (navigate: NavigateFunction, route: string) => {
  navigate(route, { replace: true });
  store.dispatch({ type: 'CLEAR_STORE' });
  persistor.purge().then(() => {
    persistor.persist();
  });
};
